import React, { Dispatch, SetStateAction } from "react";
import { NavigateFunction } from "react-router-dom";
import {
  BlueBirdTheme, Button, Divider, Popover, Typography,
} from "@kitbird/core";
import { ColumnI } from "../../../components/Table/TableProps";
import { EditIcon, ArrowSwitchIcon, DotsIcon } from "../../../assets/icons";

const columns: (
  setSelectedRow: (item: any) => void,
  setModal: (item: any) => void,
  setMoreActionElem: Dispatch<SetStateAction<HTMLElement | null>>,
  moreActionElem: HTMLElement | null,
  navigate: NavigateFunction,
) => ColumnI[] = (
  setSelectedRow,
  setModal,
  setMoreActionElem,
  moreActionElem,
  navigate,
) => [
  {
    dataIndex: "employee_id",
    key: "employee_id",
    title: "Nama & NIP user",
    width: "200px",
    render: (item, row) => (
      <div style={{ display: "flex", flexDirection: "column" }} >
        <Typography level={6} fontWeight="medium">
          {row.employee_name}
        </Typography>
        <Typography level={6} fontWeight="regular" color="#666666">
          {item}
        </Typography>
      </div>
    ),
  },
  {
    dataIndex: "employee_email",
    key: "employee_email",
    title: "Email",
    width: "260px",
  },
  {
    dataIndex: "department",
    key: "department",
    title: "Departemen",
    width: "140px",
  },
  {
    dataIndex: "job_title",
    key: "job_title",
    title: "Jabatan",
    width: "140px",
  },
  {
    dataIndex: "area_id",
    key: "area_id",
    title: "Wilayah",
    width: "60px",
  },
  {
    dataIndex: "pool_id",
    key: "pool_id",
    title: "Pool",
    width: "55px",
  },
  {
    dataIndex: "id",
    key: "id",
    title: "Action",
    width: "210px",
    render: (item, row) => {
      const onMoreActionClick = (type: "DELETE" | "DETAIL" | "HISTORY_MUTATION") => {
        setMoreActionElem(null);
        switch (type) {
          case "DELETE":
          case "DETAIL":
            setModal(type);
            break;
          case "HISTORY_MUTATION":
            navigate(`?action=history&id=${row.id}`, { state: row });
            break;
          default:
            break;
        }
      };

      const popoverMenuItems = [
        {
          label: "Lihat detail",
          onClick: () => onMoreActionClick("DETAIL"),
        },
        {
          label: "Riwayat mutasi",
          onClick: () => onMoreActionClick("HISTORY_MUTATION"),
        },
        {
          label: "Hapus data",
          onClick: () => onMoreActionClick("DELETE"),
        },
      ];

      return (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            backgroundColor={BlueBirdTheme.colors.blueGray.background}
            onClick={() => {
              setSelectedRow(row);
              navigate(`?action=mutation&id=${row.id}`, { state: row });
            }}
            style={{
              padding: "8px",
              border: `1px solid ${BlueBirdTheme.colors.gray.line}`,
            }}
          >
            <ArrowSwitchIcon width={20} height={16} />
          </Button>
          <Button
            backgroundColor={BlueBirdTheme.colors.primary[300]}
            onClick={() => {
              setSelectedRow(row);
              setModal("EDIT");
            }}
            style={{ padding: "8px" }}
          >
            <EditIcon width={20} height={16} />
          </Button>
          <Button
            backgroundColor={BlueBirdTheme.colors.blueGray.light}
            onClick={(e) => {
              setSelectedRow(row);
              setMoreActionElem(e.currentTarget);
            }}
            style={{ padding: "8px" }}
          >
            <DotsIcon width={20} height={16} />
          </Button>
          <Popover
            anchorEl={moreActionElem}
            show={Boolean(moreActionElem)}
            onClose={() => {
              setMoreActionElem(null);
              setSelectedRow(undefined);
            }}
            position="bottom-right"
            style={{
              boxShadow: "0px 1px 8px 0px rgba(63, 63, 63, 0.02)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "4px 0",
                overflow: "hidden",
              }}
            >
              {popoverMenuItems.map((menu, index) => (
                <React.Fragment key={menu.label}>
                  <div
                    onClick={() => menu.onClick()}
                    style={{
                      padding: "10px 16px",
                      cursor: "pointer",
                      width: "100%",
                    }}
                  >
                    <Typography level={5} color={BlueBirdTheme.colors.gray.subtitle}>
                      {menu.label}
                    </Typography>
                  </div>
                  {index < popoverMenuItems.length - 1 && (
                    <Divider variant="fullWidth" color={BlueBirdTheme.colors.primary[200]} />
                  )}
                </React.Fragment>
              ))}
            </div>
          </Popover>
        </div>
      );
    },
  },
];

export default columns;
